import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from './comorbidity.i18n';
import { SecondaryDisplayItem } from './secondaryDisplayItem';

export class ComorbidityDetail extends React.Component {
  configurationActive = (fieldName) => {
    if (this.props.capabilities.details.find((x) => x.fieldName === fieldName)) {
      return true;
    }
    return false;
  }

  render() {
    return (
      this.props.comorbidity.isNullMessageHolder === false ?
      <div className="row item-row" data-qa={'comorbidity_' + this.props.comorbidity.description}>
        <div className="col-md-4 primary-data">
          {
            this.props.comorbidity.isPatientReviewed === false ?
              <span className="fa fa-circle"></span> : null
          }
          {this.props.comorbidity.description}
        </div>
        <div className="col-md-8 secondary-data">
            <div className="inline-list">
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.comorbidityDiagnosisDate} />}
                value={this.props.comorbidity.comorbidityDiagnosisDate} language={this.props.language} isDate
                isActive={this.configurationActive('CormorbidityDiagnosisDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.status} />}
                value={this.props.comorbidity.status} language={this.props.language}
                isActive={this.configurationActive('Status')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerName} />}
                value={this.props.comorbidity.providerName} language={this.props.language}
                isActive={this.configurationActive('ProviderName')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.comment} />}
                value={this.props.comorbidity.comment} language={this.props.language}
                isActive={this.configurationActive('Comment')}
              />
            </div>
        </div>
      </div>
        :
      <div className="row item-row" data-qa="comorbidity_nullMessage">
        <div className="col-md-4 primary-data">
          {this.props.comorbidity.nullMessage}
        </div>
      </div>
    );
  }
}

ComorbidityDetail.propTypes = {
  comorbidity: PropTypes.object.isRequired,
  language: PropTypes.string,
  capabilities: PropTypes.object.isRequired,
};
